import {
  Button,
  Checkbox,
  FormControl,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Textarea,
  VStack,
} from "@chakra-ui/react";
import { useState } from "react";

interface CommentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (comment?: string, satisfactory?: boolean) => void;
  title?: string;
}

export default function CommentModal({
  isOpen,
  onClose,
  onSubmit,
  title = "Add Comment",
}: CommentModalProps) {
  const [comment, setComment] = useState("");
  const [satisfactory, setSatisfactory] = useState(true);

  const handleSubmit = () => {
    onSubmit(comment || undefined, satisfactory);
    setComment("");
    setSatisfactory(true);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4}>
            <FormControl>
              <FormLabel>Comment (Optional)</FormLabel>
              <Textarea
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder="Enter your comment here..."
              />
            </FormControl>
            <FormControl>
              <Checkbox
                isChecked={satisfactory}
                onChange={(e) => setSatisfactory(e.target.checked)}
              >
                Mark as satisfactory
              </Checkbox>
            </FormControl>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme={satisfactory ? "green" : "red"}
            onClick={handleSubmit}
          >
            {satisfactory ? "Approve" : "Disapprove"}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
